import React from 'react'
import { Navigate, useParams } from 'react-router-dom'

// Learning pathway detail pages moved from /learning_pathways/<slug> to
// /pathways/<slug>, but the old path is still listed in the sitemap and has no
// server-side 301, so bot/bookmark hits 404. Redirect client-side, pulling the
// slug from the URL (React Router 6's <Navigate> does not interpolate :params).
export default function PathwayRedirect() {
  const { slug } = useParams()
  return <Navigate to={`/pathways/${slug}`} replace />
}
